<script lang="ts">
import Menu from '../svelte/Menu.svelte'
</script>

<style lang="scss">
  @use '../../scss/_variables' as *;

  header {
    & .head-inner {
      width: $inner_width;
      margin: auto;
      padding: 20px 0;

      display: flex;
      align-items: center;
      justify-content: space-between;

      @media screen and (max-width: $screen_width) {
        width: $innerSP_width;
      }
    }

    h1 {
      display: inline-block;
      margin: 0;
      padding: 0;
    }

    .main-menu {
      display: flex;
      margin: 0;
      padding: 0;
      @media screen and (max-width: $screen_width) {
        display: none;
      }

      li {
        margin: 0;
        padding: 0;
        list-style-type: none;
        margin-left: 50px;
        a {
          font-style: normal;
          font-weight: 500;
          font-size: 1.4rem;
          line-height: 2;

          letter-spacing: 0.1em;

          color: #000000;

          text-decoration: none;
        }
      }
    }

    .sp-menu {
      display: none;
      @media screen and (max-width: $screen_width) {
        display: block;
      }
    }
  }
</style>

<header>
  <section class="head-inner">
    <h1>
      <img src="img/sptr-logo.svg" alt="sptr" />
    </h1>
    <ul class="main-menu">
      <li>
        <a href="#service">サービスについて</a>
      </li>
      <li>
        <a href="#about">スパトレについて</a>
      </li>
      <li>
        <a href="#career">採用情報</a>
      </li>
      <li>
        <a href="#info">お知らせ</a>
      </li>
      <li>
        <a href="mailto:info@sptr.jp">お問い合わせ</a>
      </li>
    </ul>

    <div class="sp-menu">
      <Menu />
    </div>
  </section>
</header>
